/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { useContext } from 'react';
import { Button, ButtonGroup, InputGroup } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { ManageViewsStateContext } from 'views/savedViews/useManageViewsState';

// Render the edit/delete options
export function Header({ viewName, isFavorite, toggleFavorite, onOpen, onEdit, onRename, onDelete, onCancel, onSave, onAddDescription }) {
	const {
		state: {
			isCreating,
			isEditing,
		},
	} = useContext(ManageViewsStateContext);

	return (
		<div
			css={css`
				display: flex;
				flex-direction: row;
				justify-content: space-between;
			`}
		>
			<div css={css`display: flex; align-items: center;`}>
				<FavoriteButton toggleFavorite={toggleFavorite} isFavorite={isFavorite || false}/>
				<div>
					{(isCreating || isEditing) ?
						<InputGroup placeholder={'Layout Name'} 
							value={viewName} 
							onChange={(e) => onRename(e.target.value)}
							readOnly={!isCreating && !isEditing}
						/> :
						<div css={css`padding-left: 5px;`}>{viewName}</div>
					}
				</div>
			</div>
			<ButtonGroup minimal>
				{onEdit && (
					<Button icon={'edit'} onClick={onEdit}>
						Edit
					</Button>
				)}
				{onOpen && (
					<Button icon={'document-open'} onClick={onOpen}>
						Open
					</Button>
				)}
				{onDelete && (
					<Button icon={'trash'} onClick={onDelete}>
						Delete
					</Button>
				)}
				{onAddDescription && (
					<Button onClick={onAddDescription}>
						Add Description
					</Button>
				)}
				{onCancel && (
					<Button onClick={onCancel}>
						Cancel
					</Button>
				)}
				{onSave && (
					<Button onClick={onSave}>
						Save
					</Button>
				)}
			</ButtonGroup>
		</div>
	);
}

const FavoriteButton = ({ isFavorite, toggleFavorite }) => {
	return (
		<Button 
			onClick={e => {e.stopPropagation(); toggleFavorite()}}
			icon={isFavorite ? IconNames.STAR : IconNames.STAR_EMPTY} 
			minimal 
			small 
		/>
	)
} 